// extracted by mini-css-extract-plugin
export default {"container":"ArticleFooter_container__NN64F","button":"ArticleFooter_button__Wllte","addComponentButton":"ArticleFooter_addComponentButton__lpT9J"};